module.exports = __webpack_public_path__ + "static/img/local.2553d03.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/service/local.png
// module id = fYsi
// module chunks = 1